import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button, Spin } from "antd";
import { toast } from "../../components/toasts/toastStore";
import { actionLogin } from "../../redux/actions/login/login";
import { Form, FloatingLabel } from "react-bootstrap";
import ModalOlvidar from "../../components/modals/ModalOlvidar";
import logo from "../../assets/img/logo-icon.jpg";
import loginBg from "../../assets/img/login-bg.webp";
import "../../assets/css/loginVoyager.css";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const passwordInput = useRef(null);
  const [showCorreoOptions, setShowCorreoOptions] = useState(false);

  const [show, setShow] = useState(false);
  const [correo, setCorreo] = useState("");
  const [correoOptions, setCorreoOptions] = useState([]);

  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem("email_history") || "[]");
      if (Array.isArray(saved)) setCorreoOptions(saved);
    } catch {
      setCorreoOptions([]);
    }
  }, []);

  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const openNotification = (msg) => {
    toast.error(msg || "Error");
  };

  const checkFields = () => {
    if (correo.trim().length === 0 || password.trim().length === 0) {
      openNotification("Completa correo y contraseña.");
      return false;
    }
    return true;
  };

  const callback = () => {
    navigate("/app/home");
  };

  const callbackError = (value) => {
    setLoading(false);
    openNotification(value);
  };

  const acceptButtonHandler = () => {
    if (!checkFields()) return;
    setLoading(true);
    dispatch(actionLogin({ correo, password }, callback, callbackError));
  };

  const handleKeyDownCorreo = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      passwordInput.current?.focus();
    }
  };

  const handleKeyDownPassword = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      acceptButtonHandler();
    }
  };

  return (
    <div className="login-wrapper fade-in">
      <div className="login-container">
        <div className="login-left">
          <div className="text-center">
            <img src={logo} alt="Visum Oftalmología logo" style={{ width: 140 }} />
            <h2 className="login-title">Iniciar sesión</h2>
            <p className="login-subtitle">Visum Oftalmología</p>
          </div>

          <form className="login-form" noValidate>
            <FloatingLabel controlId="floatingCorreo" label="Correo electrónico" className="mb-3">
              <Form.Control
                value={correo}
                onChange={(e) => setCorreo(e.target.value)}
                type="email"
                name="correo"
                placeholder="usuario@visumoftalmologia.com"
                onKeyDown={handleKeyDownCorreo}
                aria-label="Correo electrónico"
                autoComplete="off"
                onFocus={() => setShowCorreoOptions(true)}
                onBlur={() => setTimeout(() => setShowCorreoOptions(false), 120)}
              />

              {showCorreoOptions && correoOptions.length > 0 && (
                <div className="usuario-options-box">
                  {correoOptions
                    .filter((opt) => opt.toLowerCase().includes(correo.toLowerCase()))
                    .map((opt) => (
                      <div
                        key={opt}
                        className="usuario-option-item"
                        onMouseDown={() => {
                          setCorreo(opt);
                          passwordInput.current?.focus();
                        }}
                      >
                        {opt}
                      </div>
                    ))}
                </div>
              )}
            </FloatingLabel>

            <FloatingLabel controlId="floatingPassword" label="Contraseña">
              <Form.Control
                onChange={(e) => setPassword(e.target.value)}
                type="password"
                name="password"
                placeholder="Contraseña"
                ref={passwordInput}
                onKeyDown={handleKeyDownPassword}
                aria-label="Password"
              />
            </FloatingLabel>

            <Button
              type="primary"
              block
              className="custom-button mt-3"
              onClick={acceptButtonHandler}
              disabled={loading}
            >
              {loading ? <Spin size="small" /> : "Iniciar sesión"}
            </Button>

            <div className="forgot-password-link">
              <span className="link-pointer" onClick={() => setShow(true)}>
                ¿Olvidaste tu contraseña?
              </span>
            </div>
          </form>
        </div>

        <div
          className="login-right"
          role="presentation"
          style={{ backgroundImage: `url(${loginBg})` }}
        />
      </div>

      <ModalOlvidar show={show} setShow={setShow} />
    </div>
  );
}

export default Login;
